import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import { searchCatalog, CATALOG_IMAGES } from "../data/catalog";

export function SearchBar({ onNavigate, testid = "header-search" }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const close = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const results = searchCatalog(q);
  const go = (path) => { setOpen(false); setQ(""); onNavigate?.(); navigate(path); };

  return (
    <div ref={wrapRef} className="relative w-full" data-testid={testid}>
      <form onSubmit={(e) => { e.preventDefault(); if (results[0]) go(results[0].path); }}
        className="flex items-center gap-2 px-3 h-10 rounded-full border border-[#E2DDD5] bg-white focus-within:border-[color:var(--brand)] transition-colors">
        <Search size={16} className="text-slate-400 flex-shrink-0" />
        <input
          value={q}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onKeyDown={(e) => { if (e.key === "Escape") setOpen(false); }}
          placeholder="Search products…"
          aria-label="Search products"
          className="flex-1 min-w-0 bg-transparent text-sm focus:outline-none"
          data-testid={`${testid}-input`}
        />
        {q && <button type="button" onClick={() => setQ("")} aria-label="Clear search" className="text-slate-400" data-testid={`${testid}-clear`}><X size={14} /></button>}
      </form>
      {open && q.trim() && (
        <div className="absolute left-0 right-0 mt-2 sf-card p-2 z-50 max-h-96 overflow-auto shadow-lg min-w-[340px]" data-testid={`${testid}-results`}>
          {results.length === 0 ? (
            <div className="p-3 text-sm text-slate-500" data-testid={`${testid}-empty`}>No products match "{q}". Try "signs", "flags" or "stickers".</div>
          ) : results.map((r) => (
            <button key={r.path} onClick={() => go(r.path)} className="w-full flex items-center gap-3 p-2 rounded-xl text-left hover:bg-[#F3EFEA] transition-colors" data-testid={`${testid}-result`}>
              <div className="h-10 w-10 rounded-lg bg-[#F3EFEA] overflow-hidden flex-shrink-0 flex items-center justify-center">
                {(r.image || CATALOG_IMAGES[r.path]) ? <img src={r.image || CATALOG_IMAGES[r.path]} alt="" className="w-full h-full object-cover" /> : <Search size={14} className="text-slate-400" />}
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold leading-snug">{r.name}</div>
                <div className="text-[11px] uppercase tracking-widest text-slate-500">{r.category}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
